import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SessionQuery } from './session/session.query';
import { SessionService } from './session/session.service';
import { SessionStore } from './session/session.store';
import { AmplifyService } from '@app-services/amplify.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    SessionQuery,
    SessionService,
    SessionStore,
    AmplifyService
  ]
})
export class AppStoreModule { }
